import { ProductOptionType } from "../enumerations/product-option-types"

export interface ProductOptions {
  id: string,
  type: ProductOptionType,
  name: string
  value?: any
}